<section class="company-register" *appHasPermission="customerPermissions.MODULE">
  <div class="company-register__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
    <div class="company-register__header__map d-none">
      <i class="pi pi-map"></i>
    </div>
  </div>

  <div class="company-register__header">
    <div class="company-register__header__title">
      <div class="company-register__header__title__icon" (click)="cancelRegister()">
        <i class="pi pi-arrow-left"></i>
      </div>
      <h1>{{ tk.Management.Company | t }}</h1>
    </div>
    <div class="company-register__header__actions">
      <app-button
        theme="white"
        id="cancel-register-header"
        [label]="tk.User.Cancel | t"
        type="button"
        (sendButtonClick)="cancelRegister()"></app-button>

      <app-button
        *appHasPermission="customerPermissions.CREATE"
        id="register-group-header"
        [label]="tk.User.Finish | t"
        type="button"
        [disabled]="companyForm.invalid"
        (sendButtonClick)="registerCompany()"></app-button>
    </div>
  </div>

  <!-- PBI 3576: empresa cadastrada pelo Cog a partir do Data Room (a faixa confere CompanyAutoRegistration.VIEW). -->
  @if (companyId && registrationSource === 'CogDataRoom') {
    <app-company-auto-registration-banner [companyId]="companyId" />
  }

  <div class="company-register__content">
    <div class="company-register-form">
      <form *ngIf="companyForm" [formGroup]="companyForm" appAutoFormGroup>
        <!-- First Row: Registration Data Card (Full Width) -->
        <app-form-card
          icon="pi pi-id-card"
          title="{{ tk.General.RegistrationData | t }}"
          description="Dados cadastrais da empresa"
          customClass="registration-data-card"
          contentLayout="flex">
          <div class="fields-grid">
            <!-- ID Field -->
            <div class="field-container">
              <app-input
                [type]="'text'"
                [placeholder]="'#000000'"
                [controlName]="companyRegisterProps.id"
                [label]="tk.Management.Id | t"
                [disabled]="true"
                [required]="false">
              </app-input>
            </div>

            <!-- CNPJ Field -->
            <div class="field-container position-relative">
              <app-input
                [type]="'useMask'"
                [unmask]="true"
                mask="99.999.999/9999-99"
                [placeholder]="''"
                [controlName]="companyRegisterProps.cnpj"
                [label]="tk.General.CNPJ | t"
                (sendInputValue)="handleCnpjInput($event)"></app-input>
              <button
                pButton
                type="button"
                [title]="tk.Management.SearchDataReceitaFederal | t"
                icon="pi pi-search"
                class="p-button-rounded p-button-text company-register__search-icon"
                (click)="fetchCompanyData()"
                [disabled]="!companyForm.get(companyRegisterProps.cnpj)?.value"></button>
            </div>

            <!-- Corporate Name -->
            <div class="field-container">
              <app-input
                [type]="'text'"
                [placeholder]="''"
                [controlName]="companyRegisterProps.corporateName"
                [label]="tk.General.CorporateReason | t"></app-input>
            </div>

            <!-- Trade Name -->
            <div class="field-container">
              <app-input
                [type]="'text'"
                [placeholder]="''"
                [controlName]="companyRegisterProps.tradeName"
                [label]="
                  (tk.General.FantasyName | t) + ' (' + (tk.General.Optional | t | lowercase) + ')'
                "
                [required]="false">
              </app-input>
            </div>

            <!-- E-mail do Data Room (card 3400) -->
            <div class="field-container">
              <app-company-email-slug-field
                [form]="companyForm"
                [controlName]="companyRegisterProps.emailSlug"
                [name]="
                  companyForm.get(companyRegisterProps.tradeName)?.value ||
                  companyForm.get(companyRegisterProps.corporateName)?.value ||
                  ''
                "
                [companyId]="companyId || null" />
            </div>

            <!-- Officer (Responsável) -->
            <div class="field-container">
              <app-select
                [label]="'Responsável (Officer)'"
                [controlName]="companyRegisterProps.officerId"
                [options]="officerOptions"
                [selectedValue]="companyForm.get(companyRegisterProps.officerId)?.value"
                [allowEmptyPlaceholderSelect]="true"
                [placeholder]="tk.General.AllA | t"
                [loading]="officerOptionsLoading"
                (sendSelectedOption)="
                  companyForm.get(companyRegisterProps.officerId)?.setValue($event?.value ?? null)
                ">
              </app-select>
            </div>
          </div>
        </app-form-card>

        <!-- Second Row: Address and Additional Info Cards -->
        <div class="second-row-container">
          <!-- Address Card -->
          <app-form-card
            icon="pi pi-map-marker"
            title="Endereço"
            description="Informações de localização da empresa">
            <div class="fields-grid">
              <!-- Card 3643: o endereço em partes (o contrato de cliente usa cada uma). -->
              <div class="field-container">
                <app-input
                  [type]="'text'"
                  [placeholder]="'Rua, avenida...'"
                  [controlName]="companyRegisterProps.address"
                  [label]="'Logradouro'"></app-input>
              </div>
              <div class="field-container">
                <app-input
                  [type]="'text'"
                  [placeholder]="''"
                  [maxLength]="20"
                  [controlName]="companyRegisterProps.addressNumber"
                  [label]="'Número'"></app-input>
              </div>
              <div class="field-container">
                <app-input
                  [type]="'text'"
                  [placeholder]="'Sala, andar...'"
                  [maxLength]="100"
                  [controlName]="companyRegisterProps.addressComplement"
                  [label]="'Complemento'"></app-input>
              </div>
              <div class="field-container">
                <app-input
                  [type]="'text'"
                  [placeholder]="''"
                  [maxLength]="100"
                  [controlName]="companyRegisterProps.addressNeighborhood"
                  [label]="'Bairro'"></app-input>
              </div>
              <div class="field-container">
                <app-input
                  [type]="'text'"
                  [placeholder]="''"
                  [controlName]="companyRegisterProps.zipCode"
                  [label]="tk.General.ZipCode | t"></app-input>
              </div>
              <div class="field-container">
                <app-input
                  [type]="'text'"
                  [placeholder]="''"
                  [controlName]="companyRegisterProps.city"
                  [label]="tk.General.City | t"></app-input>
              </div>
              <div class="field-container">
                <app-input
                  [type]="'text'"
                  [placeholder]="''"
                  [controlName]="companyRegisterProps.state"
                  [label]="tk.General.Uf | t"></app-input>
              </div>
            </div>
          </app-form-card>

          <!-- Additional Info Card -->
          <app-form-card
            icon="pi pi-info-circle"
            title="Informações Adicionais"
            description="Dados complementares da empresa">
            <div class="fields-grid">
              <!-- Setor padronizado (card 3642): lista global do Back-office › Setores. -->
              <div class="field-container" *appHasPermission="companySectorPermissions.LIST">
                <app-company-sector-field
                  [form]="companyForm"
                  [controlName]="companyRegisterProps.companySectorId" />
              </div>
              <div class="field-container">
                <!-- Texto livre que o cadastro automático preenche com a descrição do CNAE. -->
                <app-input
                  [type]="'text'"
                  [placeholder]="''"
                  [controlName]="companyRegisterProps.sector"
                  [label]="'Atividade principal'"
                  [tooltipText]="
                    'Texto livre com a atividade principal (CNAE). Para agrupar e filtrar empresas, use o campo Setor.'
                  "></app-input>
              </div>
              <div class="field-container">
                <app-input
                  [type]="'text'"
                  [placeholder]="''"
                  [controlName]="companyRegisterProps.website"
                  [label]="tk.General.Site1 | t"></app-input>
              </div>
              <div class="field-container">
                <app-input
                  [type]="'number'"
                  [placeholder]="''"
                  [controlName]="companyRegisterProps.weightedAverageCost"
                  [label]="'Custo Médio Ponderado'"
                  [required]="false"></app-input>
              </div>
            </div>
          </app-form-card>
        </div>
      </form>

      <!-- Users Card -->
      <app-form-card
        icon="pi pi-users"
        title="{{ tk.General.Users | t }}"
        description="Usuários vinculados à empresa"
        customClass="users-card">
        <div slot="actions" class="d-flex align-items-center" style="gap: 10px">
          <app-button
            id="quick-add-users"
            [label]="'Cadastro Rápido'"
            [icon]="'pi pi-user-plus'"
            [text]="true"
            type="button"
            (sendButtonClick)="openQuickAdd()"></app-button>
          <app-button
            *ngIf="companyId"
            id="manage-users"
            [label]="tk.User.ManageUsers | t"
            [icon]="'pi pi-users'"
            type="button"
            (sendButtonClick)="goToUserList()"></app-button>
        </div>
        <app-table
          [items]="users"
          [columnDefinitions]="userColumns"
          [hasPagination]="false"
          [hasCheckbox]="false"
          [showSearch]="false"
          [totalRecords]="users.length"
          [rows]="users.length">
          <ng-template appNamedTemplate="fullName" let-user>
            {{ user.firstName }} {{ user.surName }}
          </ng-template>
          <ng-template appNamedTemplate="lastLogin" let-value="value">
            <span>{{ (value | vaultDateTime) || '-' }}</span>
          </ng-template>
          <ng-template appNamedTemplate="hasPassword" let-value="value">
            <div class="d-flex justify-content-center">
              <i
                class="pi"
                [ngClass]="{
                  'pi-check-circle text-success': value,
                  'pi-times-circle text-danger': !value,
                }"></i>
            </div>
          </ng-template>

          <ng-template #emptyTemplate let-items>
            <div class="empty">
              <h3 class="subTitle">{{ tk.General.NoRecordsFound | t }}</h3>
            </div>
          </ng-template>
        </app-table>
      </app-form-card>

      <!-- QSA Card -->
      <app-form-card
        icon="pi pi-user"
        title="{{ tk.General.QsaReceitaFederal | t }}"
        description="Quadro de sócios e administradores"
        customClass="qsa-card">
        <div slot="actions">
          @if (companyId) {
            <!-- Sócios lidos do contrato social pelo Cog (PBI 3260): tela própria, nunca escreve aqui. -->
            <app-button
              id="open-corporate-charter"
              [label]="'Ver Societário (contrato social)'"
              [icon]="'pi pi-sitemap'"
              [text]="true"
              type="button"
              (sendButtonClick)="openCorporateCharter()">
            </app-button>
          }
          <app-button
            id="add-partner"
            [label]="'Adicionar Sócio'"
            [icon]="'pi pi-user-plus'"
            [text]="true"
            type="button"
            (sendButtonClick)="openAddPartner()">
          </app-button>
        </div>
        <p-table [value]="partners" [tableStyle]="{ 'min-width': '50rem' }">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ tk.General.Name | t }}</th>
              <th>{{ tk.General.Qualification | t }}</th>
              <th *ngIf="visibleColumns.hasCountry">{{ tk.General.Country | t }}</th>
              <th *ngIf="visibleColumns.hasLegalRepresentative">
                {{ tk.General.LegalRepresentative | t }}
              </th>
              <th *ngIf="visibleColumns.hasLegalRepresentativeQualification">
                {{ tk.General.LegalRepresentativeQualification | t }}
              </th>
              <th style="width: 48px"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-partner let-i="rowIndex">
            <tr>
              <td>{{ partner.name }}</td>
              <td>{{ partner.qualification }}</td>
              <td *ngIf="visibleColumns.hasCountry">{{ partner.countryOfOrigin }}</td>
              <td *ngIf="visibleColumns.hasLegalRepresentative">
                {{ partner.legalRepresentativeName }}
              </td>
              <td *ngIf="visibleColumns.hasLegalRepresentativeQualification">
                {{ partner.legalRepresentativeQualification }}
              </td>
              <td class="text-center">
                <p-menu
                  #actionMenu
                  [model]="getPartnerMenuItems(partner, i)"
                  [popup]="true"
                  [appendTo]="'body'">
                </p-menu>
                <span class="ellipsis-trigger" (click)="actionMenu.toggle($event)">
                  <i class="pi pi-ellipsis-v"></i>
                </span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td
                [attr.colspan]="
                  3 +
                  (visibleColumns.hasCountry ? 1 : 0) +
                  (visibleColumns.hasLegalRepresentative ? 1 : 0) +
                  (visibleColumns.hasLegalRepresentativeQualification ? 1 : 0)
                "
                class="text-center">
                {{ tk.General.NoRecordsFound | t }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </app-form-card>

      <!-- CONTATOS DA EMPRESA.
           Mesmo painel montado na modal do menu de elipses da listagem: quem sabe listar,
           cadastrar e excluir contato e um componente so, para as duas telas nao divergirem. -->
      <app-form-card
        icon="pi pi-users"
        title="Contatos"
        description="Quem recebe cada tipo de comunicação da empresa">
        <app-company-contacts-panel [companyId]="companyId"></app-company-contacts-panel>
      </app-form-card>

      <!-- CONTRATOS DE CLIENTE (card 3643): Flat Fee e Gestão Ativa gerados para esta empresa.
           Só em edição (a empresa precisa existir) e com a permissão de listar. -->
      @if (companyId) {
        <app-form-card
          *appHasPermission="clientContractPermissions.LIST"
          icon="pi pi-file-edit"
          title="Contratos"
          description="Contratos Flat Fee e Gestão Ativa da empresa">
          <app-client-contracts [companyId]="companyId" [companyName]="contractCompanyName" />
        </app-form-card>
      }

      <!-- Footer Actions -->
      <div class="footer-actions">
        <app-button
          theme="white"
          class="action-btns"
          id="cancel-register"
          [label]="tk.User.Cancel | t"
          type="button"
          (sendButtonClick)="cancelRegister()"></app-button>

        <app-button
          *appHasPermission="customerPermissions.CREATE"
          class="action-btns"
          id="register-group"
          [label]="tk.User.Finish | t"
          type="button"
          [disabled]="companyForm.invalid"
          (sendButtonClick)="registerCompany()"></app-button>
      </div>
    </div>
  </div>

  <p-dialog
    header="Cadastro Rápido de Usuários"
    [(visible)]="showQuickAddDialog"
    [modal]="true"
    [style]="{ width: '50vw' }"
    [draggable]="false"
    [resizable]="false">
    <div class="p-fluid">
      <div class="field">
        <label for="emails" class="mb-2 d-block"
          >Emails (separados por vírgula, ponto e vírgula ou quebra de linha)</label
        >
        <textarea
          pInputTextarea
          id="emails"
          [(ngModel)]="quickAddEmails"
          rows="10"
          class="w-100"
          placeholder="exemplo@email.com, outro@email.com&#10;novo@email.com"
          autoResize="autoResize"></textarea>
      </div>

      <div class="field mt-3">
        <p-checkbox
          [(ngModel)]="sendOnboardingEmail"
          [binary]="true"
          inputId="sendOnboardingEmail"
          label="Enviar email de onboarding para os usuários pré-cadastrados">
        </p-checkbox>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <app-button
        [label]="'Cancelar'"
        [theme]="'danger'"
        [text]="true"
        (sendButtonClick)="showQuickAddDialog = false"></app-button>
      <app-button
        [label]="'Adicionar'"
        [icon]="'check'"
        (sendButtonClick)="confirmQuickAdd()"></app-button>
    </ng-template>
  </p-dialog>

  <app-company-partner-modal #partnerModal (confirmed)="onPartnerConfirmed($event)">
  </app-company-partner-modal>
</section>
